import { ScatterChart as MuiScatterChart, ScatterChartProps } from '@mui/x-charts';
import { ScatterValueType } from '@mui/x-charts/models';
import React, { useCallback } from 'react';

import { useChartLocale } from 'components/charts/hooks/use-chart-locale';
import { useLocaleAxes } from 'components/charts/hooks/use-locale-axes';
import { useLocaleSeries } from 'components/charts/hooks/use-locale-series';
import ChartThemeScope from 'components/charts/theme/chart-theme-scope';
import { ChartSurfaceProps } from 'components/charts/types/chart-surface.type';

const ScatterChart = React.forwardRef<HTMLDivElement, ScatterChartProps & ChartSurfaceProps>(function ScatterChart(
  { dark, ...props },
  ref
) {
  const { formatValue } = useChartLocale();
  const formatPoint = useCallback(
    (value: ScatterValueType | null) => value && `(${formatValue(value.x)}, ${formatValue(value.y)})`,
    [formatValue]
  );
  const series = useLocaleSeries(props.series, formatPoint);
  const xAxis = useLocaleAxes(props.xAxis);
  const yAxis = useLocaleAxes(props.yAxis);

  return (
    <ChartThemeScope dark={dark}>
      <MuiScatterChart {...props} ref={ref} series={series} xAxis={xAxis} yAxis={yAxis} />
    </ChartThemeScope>
  );
});

export default ScatterChart;
